import NotMobile from './NotMobile';

export default NotMobile;
